import { ColorButton, Icon } from '../UI';

export const StrategyLabel = ({
  className = '',
  color,
  name,
  onClose,
  viewType = 'label',
  size = 'small',
  onClick,
}: {
  className?: string;
  color: string;
  name: string;
  viewType?: 'tag' | 'label' | 'simple';
  size?: 'small' | 'base';
  onClose?(ev): void;
  onClick?(): void;
}) => (
  <div
    className={`
      ${className}
      inline-flex
      pl-2
      flex-wrap
      overflow-hidden
      justify-between
      items-center
      border
      rounded-xl
      h-9
      ${size === 'small' ? 'text-xs' : 'text-sm'}
      w-auto
      min-w-24
      max-w-44
      dark:bg-grey-80
      ${
        viewType === 'simple'
          ? 'px-0 border-transparent'
          : 'px-2 border-grey-10 dark:border-grey-70'
      }
    `}
  >
    <ColorButton
      color={color}
      isReadOnly={true}
      radius={size === 'small' ? 3 : 3.5}
    />
    <div
      className={`
        ml-2
        flex-1
        flex-grow-1
        pr-2
        min-w-0
        dark:text-white
        overflow-ellipsis
        overflow-hidden
        whitespace-nowrap
        select-none
      `}
      onClick={onClick}
    >
      {name}
    </div>
    {viewType === 'tag' && (
      <Icon
        svgName="close"
        className="h-2.5 w-2.5 mr-1 items-center cursor-pointer"
        onClick={(ev) => {
          onClose?.(ev);
        }}
      />
    )}
  </div>
);
